import React, { Component } from "react";
import styles from "./Calculator.scss";

export default class DisplayBox extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		return (
			<div
				className={styles.columnContainer}
				style={{ backgroundImage: "url(" + this.props.image + ")" }}
			>
				<div className={styles.textBox}>{this.props.text}</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/Calculator/DisplayBox.js